// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3B_J9","errorLogs":"EditorFooter_errorLogs__2RZmX"};